<template>
  <span
    class="com-app-link-common-link-text"
    @click.stop="onTextNodeClick"
  >{{ displayText }}</span>
  <!--  displayText 在mixins中定义-->
</template>
<script lang="ts" setup>
import LinkIgnore from '@/component/message/text/component/common-link/hooks/link-ignore';
import { PropType } from 'vue';
import { useToast } from '@/component/kk-toast';
const { error } = useToast();

const props = defineProps({ displayName: { type: String, default: '' }, ext: { type: Object as PropType<Record<string, unknown>>, default: () => null } });
const displayText = LinkIgnore(props.displayName);
function onTextNodeClick(): void {
  error('暂不支持跳转~');// TODO 替换toast
}
</script>

<style lang="scss">
.com-app-link-common-link-text {
  color: #267be7;
}
</style>
